/* eslint-disable */
import React, { useState, useMemo } from 'react'
import {PaymentModal} from './PaymentModal'


const BASE_WIDTH = 1920
const BASE_HEIGHT = 1080

function hexToRGBA(hexColor, alpha = 1) {
    let hex = hexColor.replace('#', '')

    // Укорачиваем #ABC → #AABBCC
    if (hex.length === 3) {
        hex = hex.split('').map((c) => c + c).join('')
    }

    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    return `rgba(${r},${g},${b},${alpha})`
}

export default function RoiOverlay({ rois = [], width = 640, height = 360 }) {
    const [open, setOpen] = useState(false)
    const [selectedRoi, setSelectedRoi] = useState(null)

    const handleOpen = (roi) => {
        setSelectedRoi(roi)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setSelectedRoi(null)
    }

    const polygons = useMemo(() => {
        return rois.map((roi) => {
            const sortedPoints = [...roi.points].sort(
                (a, b) => a.order_number - b.order_number
            )

            const scaledPoints = sortedPoints.map((pt) => {
                const sx = (pt.x / BASE_WIDTH) * width
                const sy = (pt.y / BASE_HEIGHT) * height
                return { x: sx, y: sy }
            })

            const polygonPoints = scaledPoints
                .map((p) => `${p.x},${p.y}`)
                .join(' ')

            const strokeColor = roi.paid ? '#49b370' : '#b3af49';

            const avgX =
                scaledPoints.reduce((acc, pt) => acc + pt.x, 0) / scaledPoints.length
            const avgY =
                scaledPoints.reduce((acc, pt) => acc + pt.y, 0) / scaledPoints.length

            return {
                ...roi,
                polygonPoints,
                stroke: strokeColor,
                avgX,
                avgY,
            }
        })
    }, [rois, width, height])

    return (
        <>
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width,
                    height,
                    pointerEvents: 'none',
                    overflow: 'hidden',
                }}
            >
                <svg width={width} height={height} style={{ display: 'block' }}>
                    {polygons.map((poly) => (
                        <React.Fragment key={poly.id}>
                            <polygon
                                points={poly.polygonPoints}
                                stroke={poly.stroke}
                                fill={hexToRGBA(poly.stroke, 0.3)}
                                strokeWidth={2}
                            />
                            <g transform={`translate(${poly.avgX}, ${poly.avgY})`}>
                                <rect
                                    x={-48}
                                    y={-14}
                                    width={100}
                                    height={28}
                                    fill="rgba(0, 0, 0, 0.6)"
                                    rx={6}
                                    ry={6}
                                />
                                <text
                                    x={0}
                                    y={0}
                                    fill="#ffffff"
                                    fontSize={12}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    style={{ cursor: 'pointer', pointerEvents: 'auto' }}
                                    onClick={() => handleOpen(poly)}
                                >
                                    {poly.name}
                                </text>
                            </g>
                        </React.Fragment>
                    ))}
                </svg>
            </div>

            <PaymentModal open={open} onClose={handleClose} item={selectedRoi} />
        </>
    )
}
